var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEditDisabled = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6468 6.85536L17.1106 0.319194C16.6852 -0.106073 15.9956 -0.106073 15.5702 0.319194L0.319183 15.5703C0.114874 15.7745 6.16986e-05 16.0515 0 16.3404V22.8766C0 23.4782 0.487724 23.966 1.08936 23.966H7.62553C7.91443 23.9659 8.19146 23.8511 8.39571 23.6468L23.6468 8.39572C24.072 7.97033 24.072 7.28076 23.6468 6.85536ZM7.17454 21.7872H2.17872V16.7914L13.0723 5.89782L18.0682 10.8936L7.17454 21.7872ZM16.3404 2.62973L14.6127 4.35746L19.6085 9.35327L21.3362 7.62554L16.3404 2.62973Z",
    fill: "#D2D2D2"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEditDisabled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/editDisabled.7f2143c787b5165caf5d1e1f9d51caea.svg";